import './App.css';
import Cosmetics from './components/Cosmetics/Cosmetics';
// import Calculation from './components/SumMul/SumMul';

function App() {
  return (
    <div className="App container middle">
      {/* <Calculation /> */}
      <Cosmetics />
    </div>
  );
}

export default App;
